export const availabilityReportKeys = {
  all: ['availabilityReports'] as const,
  lists: () => [...availabilityReportKeys.all, 'list'] as const,
  list: (filters?: Record<string, string>) => [...availabilityReportKeys.lists(), filters ?? {}] as const,
  details: () => [...availabilityReportKeys.all, 'detail'] as const,
  detail: (id: number) => [...availabilityReportKeys.details(), id] as const,
} as const;
